exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,500,700,800,900);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Neuton);", ""]);
exports.push([module.id, "@import url(https://use.fontawesome.com/releases/v5.8.2/css/all.css);", ""]);

// module
exports.push([module.id, "html[data-v-15099139] {\n  font-size: 62.5%;\n}\ndiv[data-v-15099139] {\n  color: #00a9e0;\n}", ""]);

// exports
